import React from 'react'
import InterfaceWrapper from './components/InterfaceWrapper'
import PaymentHistoryMain from './components/PaymentHistoryMain'

const PaymentHistory = props => {
  return <InterfaceWrapper Main={PaymentHistoryMain} {...props} />
}

export default PaymentHistory
